module.exports = __webpack_public_path__ + "static/media/SBSRCP.bfb0dec5.png";